<app-management-table
    [data]="locationObs$ | async"
    [actions]="getTableActions()"
    [mapper]="getTableMapper()">
</app-management-table>
